module.exports = __webpack_public_path__ + "static/media/galerija_2019 (20).4c70814c.jpg";